var codeModal = document.getElementById('codeModal');
var finishCallback;
var urlPrefix;
var useUpdateEndpoint;
var lastResponse;

codeModal.addEventListener('show.bs.modal', event => {
    const code = getCode();
    if (code) {
        $('.pm-code-dialog input[name="code"]').val(code);
    }
});

codeModal.addEventListener('hidden.bs.modal', event => {
    if (finishCallback) {
        finishCallback(lastResponse);
    }
    lastResponse = null;
});
var modal = new bootstrap.Modal(codeModal);

$('.pm-code-dialog input[name="code"]').on('input', function() {
    const codeInput = $(this);
    const cursorPosition = codeInput.selectionStart;
    let value = codeInput.val();
    if (value.length > 4 && value[4] != '-') {
        value = value.slice(0, 4) + '-' + value.slice(4);
    }
    if (value.length > 9 && value[9] != '-') {
        value = value.slice(0, 9) + '-' + value.slice(9);
    }
    codeInput.val(value.substring(0, 14).toUpperCase());
    codeInput.selectionStart = cursorPosition;
});

function onClearCode(ev) {
    ev.preventDefault();

    removeCode();
    lastResponse = null;
    modal.hide();
}

function onSetCode(ev) {
    ev.preventDefault();
    
    const code = $('.pm-code-dialog input[name="code"]').val();
    showDialogSpinner();
    const currentUuid = getUuid() || 'none';
    const endpoint = useUpdateEndpoint ? 'update-code' : 'verify-code';
    const apiUrl = window.PM_CONFIG.apiUrl + '/' + urlPrefix + '-' + endpoint + '/' + code + '/' + currentUuid;
    postCode(apiUrl,
        function(response) {
            hideDialogSpinner();
            setCode(code);
            if (response && response.uuid) {
                setUuid(response.uuid);
            }
            lastResponse = response;
            modal.hide();
        },
        function(jqXHR, textStatus, errorThrown) {
            hideDialogSpinner();
            if (jqXHR.responseJSON && jqXHR.responseJSON.uuid) {
                setUuid(jqXHR.responseJSON.uuid);
            }
            if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                showDialogError(jqXHR.responseJSON.error);
            }
            else {
                showDialogError("code.invalid_code_msg");
            }
        }
    );
}

function showDialogError(msgCode) {
    let msg = translate(msgCode);
    $('.pm-dialog-error-container .alert').alert('close');
    let alertMsg = `<div class="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>` + msg + `</strong>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>`;
    $('.pm-dialog-error-container').prepend(alertMsg);
}

function showDialogSpinner() {
    $('.pm-dialog-overlay').removeClass('visually-hidden');
}

function hideDialogSpinner() {
    let hidden = $('.pm-dialog-overlay').hasClass('visually-hidden');
    if (!hidden) {
        $('.pm-dialog-overlay').addClass('visually-hidden');
    }
}

function showCodeDialog(product, allowSkipping, callback, useUpdateCodeEndpoint)  {
    if (!product) {
        return;
    }
    urlPrefix = product;
    useUpdateEndpoint = !!useUpdateCodeEndpoint;
    lastResponse = null;
    const titleKey = product + '.enter_product_code';
    const titleEl = document.getElementById('codeModalLabel');
    titleEl.setAttribute('data-i18n', titleKey);
    titleEl.textContent = translate(titleKey);
    const skipInfoKey = product + '.skip_code_entry';
    const skipInfoEl = document.querySelector('.pm-code-dialog-info');
    skipInfoEl.setAttribute('data-i18n', skipInfoKey);
    skipInfoEl.textContent = translate(skipInfoKey);
    modal.show();
    if (allowSkipping) {
        $('.pm-code-dialog-info').removeClass('visually-hidden');
    }
    if (callback) {
        finishCallback = callback;
    }
}
